var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-manager"},[_c('Header'),_c('v-main',{key:`update-on-settings-change-${_vm.settings.reportingSimpleView}-${_vm.settings.defaultActivityType}`},[(_vm.isSettingsLoaded)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }